export default {"src":"/_next/static/image/public/images/ic_cancel.9a5404f712c544180c23aad407fda07a.svg","height":17,"width":17};